import { useQuery } from '../../../query-context';
import { filterAllSectionItems, highlightPostQueryResultTitles } from '../../../product-router/product/result-provider/faster-search-helpers';
var RECENTLY_VIEWED_ITEMS_SHOWN = 10;

/**
 * This component takes care of filtering results matching the entered query.
 */
export var QueryFilterTransformer = function QueryFilterTransformer(_ref) {
  var preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    productState = _ref.productState,
    children = _ref.children;
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var filteredPreQueryItems = filterAllSectionItems({
    sections: preQueryItems.sections,
    size: preQueryItems.size
  }, query, RECENTLY_VIEWED_ITEMS_SHOWN);
  var highlightedPostQueryItems = highlightPostQueryResultTitles(postQueryItems, query);
  return children({
    preQueryItems: filteredPreQueryItems,
    postQueryItems: highlightedPostQueryItems,
    productState: productState
  });
};